import { render, staticRenderFns } from "./PlaceUsersComponent.vue?vue&type=template&id=0e4d9966&"
import script from "./PlaceUsersComponent.vue?vue&type=script&lang=js&"
export * from "./PlaceUsersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports